import React from 'react';

const SITE_URL = 'https://24betbox.com';
const DEFAULT_IMG = `${SITE_URL}/og-image.jpg`;

// Renders document metadata. React 19 automatically hoists <title>, <meta>
// and <link> to the document <head>. JSON-LD is injected as script blocks
// (Google reads structured data anywhere in the DOM).
export default function Seo({ title, description, path = '', image, type = 'website', jsonLd }) {
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMG;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="24BetBox" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(b) }} />
      ))}
    </>
  );
}
